import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import RequiredFieldMessage from "../common/userMessages/requiredFieldMessage";
import TaskComplete from "../common/taskComplete";
import userService from "../../services/userService";
import EmployersForm from "../forms/pageForms/employersForm";
import { getEmployersInputs } from "../forms/formEntities/employersEntities";
import { useTranslation, Trans } from "react-i18next";
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from "react-bootstrap";
import SaveAndContinueUserMessage from "../common/userMessages/saveAndContinueMessage";
export default function Employers({
  user,
  userData,
  updatePage,
  shake,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const employersInputs = getEmployersInputs(t);
  const [employers, setEmployers] = useState([]);
  const [noEmployers, setNoEmployers] = useState(false);

  const [showPageReqsMessage, setShowPageReqsMessage] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const onModalHide = () => {
    setModalShow(false);
    setNoEmployers(false);
  };

  const handleNoEmployers = () => {
    setNoEmployers(!noEmployers);
    setModalShow(true);
  };

  const handleSkipStep = async () => {
    const updatedEmployment = {
      isComplete: true,
      neverEmployed: noEmployers,
      employers: [],
    };
    userData.employment = updatedEmployment;
    updatePage();
    navigate("../phase2-references");

    await userService.saveUserData(user, "employment", updatedEmployment);
  };

  const handleEmployerDelete = async (index) => {
    employers.splice(index, 1);
    setEmployers(employers);
    updatePage();

    await userService.saveUserData(user, "employment", {
      neverEmployed: noEmployers,
      employers: employers,
    });
    userData.employement = {
      neverEmployed: noEmployers,
      employers: employers,
    }
  };

  const handlePageReqs = (data) => {
    if (data && data.length >= 1) {
      setShowPageReqsMessage(false);
      return true;
    } else {
      setShowPageReqsMessage(true);
      shake();
      return false;
    }
  };

  const handleSubmitAndContinue = async () => {
    if (handlePageReqs(employers)) {
      updatePage();
      setShowPageReqsMessage(false);
      navigate("../phase2-references");
      await userService.saveUserData(user, "employment", {
        isComplete: true,
        ...userData.employment,
      });
      userData.employment = {
        isComplete: true,
        ...userData.employment,
      };
    } else {
      // alert("error");
    }
  };

  // Assigning input names as keys for initialValues
  const inputKeys = employersInputs.map((input) => {
    let keys = input.name;
    return keys;
  });

  // Creating initialValues by setting input keys to each have empty string value
  const initialValues = inputKeys.reduce((acc, key) => {
    acc[key] = "";
    return acc;
  }, {});

  const handleFormikSubmit = async (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (values[key] === "" || !values[key]) {
        delete values[key];
      }
    });
    let newEmployerArr = [...employers, { ...values }];
    if (noEmployers) {
      handleSkipStep();
    } else {
      await userService.saveUserData(user, "employment", {
        neverEmployed: noEmployers,
        employers: newEmployerArr,
      });
      userData.employment = {
        neverEmployed: noEmployers,
        employers: newEmployerArr,
      };
      actions.resetForm(initialValues);
      setEmployers(newEmployerArr);
      handlePageReqs(newEmployerArr);
    }
    updatePage();
  };

  useEffect(() => {
    if (userData && userData.employment) {
      setEmployers(userData.employment.employers);
    }
  }, [userData]);

  return (
    <>
      {/* {userData.employment && userData.employment.isComplete ? (
        <section className="main-section">
          <h2>Employment History</h2>
          <section className="main-section-content">
            <TaskComplete
              pageTitle={"Employment History"}
              nextLink="phase2-references"
            />
          </section>
        </section>
      ) : (
        <> */}
      {/* No Employment Information Modal  */}
      <Modal show={modalShow} centered>
        <ModalHeader as="span" className="alert alert-info">
          <ModalTitle as="h4">{t("employers.modal.title")}</ModalTitle>
        </ModalHeader>
        <ModalBody as="section">
          <p>{t("employers.modal.body1")}</p>
          <p>
            <Trans i18nKey="employers.modal.body2" components={{ strong: <strong /> }} />
          </p>
          <p>
            <Trans i18nKey="employers.modal.body3" components={{ strong: <strong /> }} />
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between" as="footer">
          <SaveAndContinueUserMessage messageType="save" />
          <Button onClick={handleFormikSubmit}>{t("common.save")}</Button>
          <Button variant="outline-primary" onClick={onModalHide}>{t("common.cancel")}</Button>
        </ModalFooter>
      </Modal>
      <section className="main-section">
        <h2>{t("employers.historyTitle")}</h2>
        <div className="main-section-content text-start">
          {/* Page Instructions  */}
          <section className="text-start">
            <p>{t("employers.intro")}</p>

            <p>{t("employers.followDirections")}</p>
            <p>{t("employers.addUpTo3")}</p>
          </section>
          {employers && employers.length === 0 && (
            <div className="alert alert-info" role="alert">
              <p>{t("employers.pageReqs1")}</p>
              <p>{t("employers.pageReqs2")}</p>
            </div>
          )}
        </div>
      </section>

      {/* Form Section  */}
      <section className="main-section">
        <h2>{t("employers.formTitle")}</h2>
        <section className="main-section-content">
          {/* Form Section - Instructions  */}
          <section className="text-start">
            <p>{t("employers.formInstructions")}</p>
            <p>{t("employers.requiredFieldIndicator")}</p>
            <p>{t("employers.reviewInstructions")}</p>
          </section>

          {/* Form Section - Form  */}
          <EmployersForm
            shake={shake}
            employers={employers}
            initialValues={initialValues}
            handleFormikSubmit={handleFormikSubmit}
            handleNoEmployers={handleNoEmployers}
            noEmployers={noEmployers}
            userData={userData}
          />
        </section>
      </section>

      {/* Review and Submit Section  */}
      {!noEmployers && (
        <section className="main-section">
          <h2>{t("employers.reviewTitle")}</h2>

          <section className="main-section-content">
            {/* Review and Submit - Instructions  */}
            <section className="text-start">
              <p>{t("employers.reviewDeleteInstructions")}</p>
              <p>{t("employers.reviewNextInstructions")}</p>
            </section>

            {/* Review and Submit Section - Review Table  */}
            <section
              style={{ border: "1px solid black", marginBottom: "1rem" }}
            >
              {employers && employers.length > 0 ? (
                <Table striped bordered hover responsive size="sm">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{t("employers.table.name")}</th>
                      <th>{t("employers.table.phone")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employers.map((employer, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => handleEmployerDelete(index)}
                            size="sm"
                            disabled={userData.submissionDate}
                          >
                            {t("employers.table.delete")}
                          </Button>
                        </td>
                        <td>{employer.employerName}</td>
                        <td>{employer.employerPhone}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="mb-0">{t("employers.noEntriesMessage")}</p>
              )}
            </section>

            {/* Review and Submit Section - Submit  */}
            <section>
              <RequiredFieldMessage
                handleClick={() => navigate("../phase2-references")}
                show={showPageReqsMessage ? true : false}
                reqMessage={t("employers.pageReqMessage")}
                hasButton={true}
              />
              <SaveAndContinueUserMessage messageType="save and continue" />
              <Button variant="primary" onClick={handleSubmitAndContinue} >
                {t("common.saveAndContinue")}
              </Button>
            </section>
          </section>
        </section>
      )}
      {/* </>
      )} */}
    </>
  );
}
